export default __webpack_public_path__ + "img/cafd277f9fcea7e53d58dcfb99f7f57c.svg";